import React, { forwardRef, ForwardRefRenderFunction, useImperativeHandle } from "react";
import { Input, Form } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { FormInstance } from "../../../../hooks/createForm";
import { User } from "authing-js-sdk";
import { useTranslation } from "react-i18next";
// import { getUserRegisterParams } from '../../../../utils';

export interface ADLoginFormProps extends React.HTMLAttributes<HTMLDivElement> {
  onSubmit?: () => void;
  onSuccess?: (user: User) => void;
  onFail?: (error: any) => void;
  onFinishFailed?: (error: any) => void;
}

const InternalADLoginForm: ForwardRefRenderFunction<FormInstance, ADLoginFormProps> = (
  { onSubmit, onSuccess, onFail, onFinishFailed },
  ref
) => {
  const [rawForm] = Form.useForm();
  const config = window.__config__;
  const { t } = useTranslation();
  const onFinish = async (values: any) => {
    try {
      const authenticationClient = window.__authing__;
      const identity = values.identity && values.identity.trim();
      const password = values.password && values.password.trim();
      const user = await authenticationClient.loginByAd(identity, password);
      onSuccess && onSuccess(user);
    } catch (error) {
      if (typeof error.message === "string") {
        // js sdk httpclient 的报错，这里只有一种情况就是用户开启了 mfa 的报错
        try {
          const errorData = JSON.parse(error.message);
          onFail && onFail(errorData);
          return;
        } catch (_) {}
      }
      onFail && onFail(error);
    }
  };

  useImperativeHandle(ref, () => ({
    submit: async () => {
      try {
        onSubmit && onSubmit();
        await rawForm.validateFields();
        rawForm.submit();
      } catch (error) {
        onFail && onFail(error);
      }
    },
  }));

  return (
    <Form form={rawForm} onSubmitCapture={onSubmit} onFinishFailed={onFinishFailed} onFinish={onFinish}>
      <button type="submit" hidden></button>

      {config.ssoPageComponentDisplay.userPasswordInput && (
        <>
          <Form.Item
            name="identity"
            rules={[
              {
                required: true,
                message: t("login.inputAdUsername"),
              },
            ]}
          >
            <Input
              autoComplete="email,username,tel"
              size="large"
              placeholder={t("login.inputAdUsername")}
              prefix={<UserOutlined style={{ color: "#ddd" }} />}
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: t("login.inputAdPwd"),
              },
            ]}
          >
            <Input.Password
              autoComplete="current-password"
              size="large"
              visibilityToggle={false}
              placeholder={t("login.inputAdPwd")}
              prefix={<LockOutlined style={{ color: "#ddd" }} />}
            />
          </Form.Item>
        </>
      )}
    </Form>
  );
};

export const ADLoginForm = forwardRef<FormInstance, ADLoginFormProps>(InternalADLoginForm);
